import { connect } from 'react-redux';
import { getAllOperatorData as getOperatorData } from '../../redux/actions/operator';
import {
  getRefundCompletedData,
  getRefundsSummary,
  addComment,
  updateStatus,
  uploadFiles,
  getRefundsCount,
  getTransactions,
  makeRefund,
  makeRefunds,
  switchMethod
} from '../../redux/actions/refunds';
import { RefundManager } from '../../components';

const mapStateToProps = (state) => ({
  operators: state.operator.allData,
  refunds: state.refunds.data,
  summary: state.refunds.summaryData,
  entities: Array.from(new Set(state.refunds.summaryData.map(item => item._id.entity))),
  loading: state.refunds.loading,
  uploading: state.refunds.uploading,
  refundCount: state.refunds.refundCount,
  transactions: state.refunds.transactions,
  refunding: state.refunds.refunding,
  loadingTransactions: state.refunds.loadingTransactions,
  switching: state.refunds.switching
})

const mapDispatchToProps = {
  getOperatorData,
  getRefundData: getRefundCompletedData,
  getRefundsSummary,
  addComment,
  updateStatus,
  uploadFiles,
  getRefundsCount,
  getTransactions,
  makeRefund,
  makeRefunds,
  switch: switchMethod
};

export default connect(mapStateToProps, mapDispatchToProps)(RefundManager);



// WEBPACK FOOTER //
// ./src/containers/RefundManager/RefundManager.js